/* tslint:disable */
/* eslint-disable */
/**
 * Контроль місій для FPV
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { OutputUavMissionsReportItem } from './OutputUavMissionsReportItem';
import {
    OutputUavMissionsReportItemFromJSON,
    OutputUavMissionsReportItemFromJSONTyped,
    OutputUavMissionsReportItemToJSON,
} from './OutputUavMissionsReportItem';

/**
 * 
 * @export
 * @interface OutputUavMissionsReportSection
 */
export interface OutputUavMissionsReportSection {
    /**
     * 
     * @type {number}
     * @memberof OutputUavMissionsReportSection
     */
    flights: number;
    /**
     * 
     * @type {Array<OutputUavMissionsReportItem>}
     * @memberof OutputUavMissionsReportSection
     */
    platforms: Array<OutputUavMissionsReportItem>;
    /**
     * 
     * @type {number}
     * @memberof OutputUavMissionsReportSection
     */
    requests: number;
    /**
     * 
     * @type {string}
     * @memberof OutputUavMissionsReportSection
     */
    type: string;
    /**
     * 
     * @type {Array<OutputUavMissionsReportItem>}
     * @memberof OutputUavMissionsReportSection
     */
    units: Array<OutputUavMissionsReportItem>;
}

/**
 * Check if a given object implements the OutputUavMissionsReportSection interface.
 */
export function instanceOfOutputUavMissionsReportSection(value: object): boolean {
    if (!('flights' in value)) return false;
    if (!('platforms' in value)) return false;
    if (!('requests' in value)) return false;
    if (!('type' in value)) return false;
    if (!('units' in value)) return false;
    return true;
}

export function OutputUavMissionsReportSectionFromJSON(json: any): OutputUavMissionsReportSection {
    return OutputUavMissionsReportSectionFromJSONTyped(json, false);
}

export function OutputUavMissionsReportSectionFromJSONTyped(json: any, ignoreDiscriminator: boolean): OutputUavMissionsReportSection {
    if (json == null) {
        return json;
    }
    return {
        
        'flights': json['flights'],
        'platforms': ((json['platforms'] as Array<any>).map(OutputUavMissionsReportItemFromJSON)),
        'requests': json['requests'],
        'type': json['type'],
        'units': ((json['units'] as Array<any>).map(OutputUavMissionsReportItemFromJSON)),
    };
}

export function OutputUavMissionsReportSectionToJSON(value?: OutputUavMissionsReportSection | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'flights': value['flights'],
        'platforms': ((value['platforms'] as Array<any>).map(OutputUavMissionsReportItemToJSON)),
        'requests': value['requests'],
        'type': value['type'],
        'units': ((value['units'] as Array<any>).map(OutputUavMissionsReportItemToJSON)),
    };
}

